import { Link } from 'react-router-dom';
import type { AnchorHTMLAttributes } from 'react';

/** SPA navigation via react-router (replaces vinext NativeLink). */
export function NativeLink({ href = '/', ...props }: AnchorHTMLAttributes<HTMLAnchorElement> & { href?: string }) {
  return <Link to={href} {...props} />;
}
